module.exports = __webpack_public_path__ + "img/Logos Powered by 2.3e7966eb.svg";